<template>
    <li
        v-show="show"
        :class="{ active: isActive && !isInDropdown }"
        class="legacy:tw-text-sm legacy:2xl:tw-text-base"
    >
        <a
            :href="href"
            :target="options && options.external ? '_blank' : ''"
            :data-test-id="
                options && options.testId
                    ? options.testId
                    : href.replace('#/', 'menu-').replace(/\//g, '-')
            "
            class="legacy:menu-item"
            :class="linkClass"
            @click.stop="$emit('navigation')"
        >
            <slot />{{ text }}
        </a>
    </li>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        linkClass: {
            type: String,
        },
        options: {
            type: Object,
        },
        isInDropdown: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isActive() {
            return `#${this.$route.path}`.startsWith(this.href) ?? false;
        },
    },
};
</script>

<style scoped>
/* Remove once using tailwind JIT or legacy styles got removed */
.legacy\:menu-item {
    max-height: 50px !important;
}

.legacy\:tw-text-sm {
    @apply tw-text-sm !important;
}

@media (min-width: 1300px) {
    .legacy\:2xl\:tw-text-base {
        @apply tw-text-base !important;
    }
}
</style>
